import { MemberBadge } from '../../../types/entity.types';
import { UpdateMemberBadgesRequest, ViewmemberBadgesRequest } from './member-badge.types';

import {
  API_HOST,
  HttpGetOptions,
  HttpPutOptions,
  getHttpGetOptions,
  getHttpPutOptions
} from '../../../utils/api.util';

const getEndpoint = (memberExternalReference: string) => `${API_HOST}/member/${memberExternalReference}/badges`;

export const getViewMemberBadgesRequest = (data: ViewmemberBadgesRequest): [string, HttpGetOptions] => [
  getEndpoint(data.memberExternalReference),
  getHttpGetOptions()
];

export const getUpdateMemberBadgesRequest = (
  data: UpdateMemberBadgesRequest
): [string, HttpPutOptions<{ memberBadges: MemberBadge[] }>] => [
  getEndpoint(data.memberExternalReference),
  getHttpPutOptions({ memberBadges: data.memberBadges })
];
